<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-2">
      <v-navigation-drawer
        v-model="drawer"
        app
        right
      >
        <v-list dense class="px-3 mb-6">
          <v-subheader class="ml-2">
            <span class="text-uppercase">Filter Awards</span>
          </v-subheader>
          <v-list-item>
            <v-select
              v-model="frequenciesFilter"
              :items="frequencies"
              :menu-props="{ maxHeight: '400' }"
              label="Frequency of Award"
              multiple
              dense
              filled
              clearable
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="geofocusesFilter"
              :items="geofocuses"
              item-text="name"
              item-value="id"
              :menu-props="{ maxHeight: '400' }"
              label="Geographical Focus"
              multiple
              dense
              filled
              clearable
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-autocomplete
              v-model="countriesFilter"
              :items="countries"
              item-text="name"
              item-value="id"
              :menu-props="{ maxHeight: '400' }"
              label="Country"
              multiple
              dense
              filled
              clearable
            ></v-autocomplete>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="themesFilter"
              :items="themes"
              item-text="name"
              item-value="id"
              :menu-props="{ maxHeight: '400' }"
              label="Award Theme"
              multiple
              dense
              filled
              clearable
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="establishmentYearFilter"
              :items="years"
              label="Year of Establishment"
              dense
              filled
              clearable
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="nominationsFilter"
              :items="nominations"
              :menu-props="{ maxHeight: '400' }"
              label="Public Nominations"
              multiple
              dense
              filled
              clearable
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="prizeMoneyFilter"
              :items="prizeMoney"
              :menu-props="{ maxHeight: '400' }"
              item-text="label"
              label="Prize Money"
              multiple
              dense
              filled
              small-chips
              return-object
              clearable
            ></v-select>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Deadline</v-list-item-title>
              <v-list-item-subtitle>
                <v-menu
                  ref="menuDeadlineDateFrom"
                  v-model="menuDeadlineDateFrom"
                  :close-on-content-click="false"
                  :return-value.sync="deadlineDateFrom"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="deadlineDateFrom"
                      label="Date From"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="deadlineDateFrom" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuDeadlineDateFrom = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menuDeadlineDateFrom.save(deadlineDateFrom)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <v-menu
                  ref="menuDeadlineDateTo"
                  v-model="menuDeadlineDateTo"
                  :close-on-content-click="false"
                  :return-value.sync="deadlineDateTo"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="deadlineDateTo"
                      label="Date To"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="deadlineDateTo" no-title scrollabl>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuDeadlineDateTo = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menuDeadlineDateTo.save(deadlineDateTo)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Upcoming Ceremony</v-list-item-title>
              <v-list-item-subtitle>
                <v-menu
                  ref="menuUpcomingCeremonyDateFrom"
                  v-model="menuUpcomingCeremonyDateFrom"
                  :close-on-content-click="false"
                  :return-value.sync="upcomingCeremonyDateFrom"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="upcomingCeremonyDateFrom"
                      label="Date From"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="upcomingCeremonyDateFrom" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuUpcomingCeremonyDateFrom = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menuUpcomingCeremonyDateFrom.save(upcomingCeremonyDateFrom)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <v-menu
                  ref="menuUpcomingCeremonyDateTo"
                  v-model="menuUpcomingCeremonyDateTo"
                  :close-on-content-click="false"
                  :return-value.sync="upcomingCeremonyDateTo"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="upcomingCeremonyDateTo"
                      label="Date To"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="upcomingCeremonyDateTo" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuUpcomingCeremonyDateTo = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menuUpcomingCeremonyDateTo.save(upcomingCeremonyDateTo)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Cease to Exist</v-list-item-title>
              <v-list-item-subtitle>
                <v-checkbox v-model="ceasedToExistYes" class="ml-2" label="Yes"></v-checkbox>
                <v-checkbox v-model="ceasedToExistNo" class="ml-2 mt-n2" label="No"></v-checkbox>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn
                @click="refreshFilters()"
                outlined
                color="accent"
              >
                <v-icon left>mdi-autorenew</v-icon>
                Refresh
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-container class="mb-4">
        <v-row>
          <v-card class="width-100">
            <v-toolbar flat class="indigo lighten-5">
              <v-text-field
                solo
                flat
                dense
                label="Search"
                style="max-width: 280px"
                hide-details
                v-model="search"
                :class="[search && !filteredAwards.length ? 'search-no-results' : 'search']"
              >
                <template v-slot:prepend-inner>
                  <v-icon>mdi-magnify</v-icon>
                </template>
                <template v-slot:append v-if="search">
                  <v-btn small icon class="mr-n1" @click="search = ''">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <v-spacer></v-spacer>

              <span class="caption mx-1 hidden-sm-and-down">Rows per page</span>
              <div style="max-width: 60px" class="mx-3">
                <v-select
                  v-model="pageSize"
                  :items="[20, 50, 100]"
                  dense
                  hide-details
                ></v-select>
              </div>

              <v-btn
                @click.stop="drawer = !drawer"
                icon
              >
                <v-icon class="text-subtitle">mdi-filter-outline</v-icon>
              </v-btn>
            </v-toolbar>

            <v-simple-table>
              <template v-slot:default>
                <thead v-if="filteredAwards.length">
                  <tr class="indigo-lighten-6">
                    <th></th>
                    <th
                      @click="sortBy('name')"
                      class="th-award-name th-clickable"
                    >Award Name</th>
                    <th
                      @click="sortByObj('country')"
                      class="th-clickable"
                    >Country</th>
                    <th
                      @click="sortByYearFounded()"
                      class="text-right th-clickable"
                    >Year Founded</th>
                    <th
                      @click="sortByPrizeMoney()"
                      class="text-right th-clickable"
                    >Prize Money</th>
                    <th
                      @click="sortByObj('theme')"
                      class="th-award-theme th-clickable"
                    >Award Theme</th>
                    <th>Geographical Focus</th>
                    <th
                      @click="sortBy('frequency')"
                      class="th-clickable"
                    >Award Frequency</th>
                    <th
                      @click="sortBy('nomination')"
                      class="th-clickable"
                    >Public Nominations</th>
                    <th>Upcoming Ceremony</th>
                    <th
                      @click="sortBy('deadline')"
                      class="th-deadline th-clickable"
                    >Deadline</th>
                    <th>Email</th>
                    <th>Website</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, $index) in paginatedAwards"
                    :key="$index"
                    @click="goToAward(item.id)"
                    class="blue-grey--text text--darken-3 tr-award"
                  >
                    <td class="py-1 td-avatar">
                      <img
                        v-if="item.image"
                        :src="`${baseURL}/img/awards/350/${item.image}`"
                      >
                      <v-avatar v-else color="blue-grey lighten-5">
                        <span class="blue-grey--text text--darken-1">
                          {{ item.name | capitalizeName }}
                        </span>
                      </v-avatar>
                    </td>
                    <td>
                      <span>{{ item.name }}</span>
                    </td>
                    <td>
                      <span v-if="item.country">{{ item.country.name }}</span>
                    </td>
                    <td class="text-right">{{ item.establishment_year }}</td>
                    <td class="text-right">
                      <span v-if="item.prize_money">{{ parseInt(item.prize_money).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }) }}</span>
                    </td>
                    <td>
                      <span v-if="item.themes.length === 1">{{ item.themes[0].name }}</span>
                      <li v-else v-for="(theme, $index) in item.themes" :key="$index + item.id + '-' + theme.id">
                        <span>{{ theme.name }}</span>
                      </li>
                    </td>
                    <td>
                      <div v-if="item.geofocuses.length">
                        <span v-for="geofocus in item.geofocuses" :key="geofocus.id">{{ geofocus.name }} </span>
                      </div>
                    </td>
                    <td>{{ item.frequency }}</td>
                    <td>{{ item.nomination }}</td>
                    <td>
                      <div v-if="item.ceremony_dates">
                        <span v-for="(dt, $index) in JSON.parse(item.ceremony_dates)" :key="$index">{{ dt }} </span>
                      </div>
                    </td>
                    <td>
                      <span v-if="item.deadline">{{ moment(item.deadline).format('L') }}</span>
                    </td>
                    <td>
                      <a class="email-address" :href="`mailto:${item.email}`">{{ item.email }}</a>
                    </td>
                    <td>
                      <a :href="item.website" target="_blank" >
                        {{ item.website }}
                      </a>
                    </td>
                    <td>
                      <v-btn
                        @click.stop="callConfirmAwardDeleteDialog(item)"
                        icon
                      >
                        <v-icon class="text-subtitle">mdi-delete-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <div v-if="!filteredAwards.length" class="mx-4 my-6 grey--text text--darken-1 text-center width-100">
            No matching <span class="font-weight-medium">Awards</span> found in the database
          </div>
        </v-row>

        <v-row justify="center" v-if="filteredAwards.length">
          <v-col cols="8">
            <v-container>
              <v-pagination
                v-model="pageNumber"
                :length="pagesQty"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <v-btn
        link
        :to="{ name: 'awards.create' }"
        dark
        fab
        bottom
        right
        fixed
        color="primary"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <!-- Confirm Delete Award Dialog-->
      <confirm-delete-award-dialog
        ref="confirmAwardDeleteDialog"
        :award="awardToDelete"
      ></confirm-delete-award-dialog>

    </div>
  </div>
</template>

<script>
import ConfirmDeleteAwardDialog from '@/components/awards/ConfirmDeleteAwardDialog.vue'
import Loader from '@/components/Loader'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'Awards',

  mixins: [messagesMixin],

  components: {
    ConfirmDeleteAwardDialog,
    Loader
  },

  data () {
    return {
      awards: [],
      awardToDelete: {},
      ceasedToExistYes: false,
      ceasedToExistNo: false,
      countries: [],
      countriesFilter: [],
      deadlineDateFrom: null,
      deadlineDateTo: null,
      drawer: false,
      establishmentYearFilter: '',
      frequencies: ['Annual', 'Bi-Annual', 'Occasional', 'Unknown'],
      frequenciesFilter: [],
      geofocuses: [],
      geofocusesFilter: [],
      menuDeadlineDateFrom: false,
      menuDeadlineDateTo: false,
      menuUpcomingCeremonyDateFrom: false,
      menuUpcomingCeremonyDateTo: false,
      nominations: ['Yes', 'No', 'Unknown'],
      nominationsFilter: [],
      pageLoaded: false,
      pageNumber: 1,
      pageSize: 20,
      prizeMoney: [
        {
          min: '',
          max: '',
          label: 'Yes'
        },
        {
          min: '',
          max: '',
          label: 'No'
        },
        {
          min: '',
          max: '',
          label: 'Unknown'
        },
        {
          min: 0,
          max: 1000,
          label: '0 - 1000'
        },
        {
          min: 1001,
          max: 5000,
          label: '1 001 - 5 000'
        },
        {
          min: 5001,
          max: 10000,
          label: '5 001 - 10 000'
        },
        {
          min: 10001,
          max: 30000,
          label: '10 001 - 30 000'
        },
        {
          min: 30001,
          max: 100000,
          label: '30 001 - 100 000'
        },
        {
          min: 100001,
          max: 3000000,
          label: '100 000 ...'
        }
      ],
      prizeMoneyFilter: [],
      search: '',
      sortByNameAsc: true,
      themes: [],
      themesFilter: [],
      upcomingCeremonyDateFrom: null,
      upcomingCeremonyDateTo: null
    }
  },

  mounted () {
    Promise.all([
      this.getAwards(),
      this.getCountries(),
      this.getGeofocuses(),
      this.getThemes()
    ])
      .then(() => {
        this.pageLoaded = true
      })
  },

  computed: {
    filteredAwards () {
      const search = this.search ? this.search.toLowerCase() : ''

      let awards = this.awards.filter(item => item.name.toLowerCase().includes(search))

      if (this.frequenciesFilter.length) {
        awards = awards.filter(item => this.frequenciesFilter.find(i => i === item.frequency))
      }

      if (this.geofocusesFilter.length) {
        awards = awards.filter(item => item.geofocuses.find(i => this.geofocusesFilter.includes(i.id)))
      }

      if (this.countriesFilter.length) {
        awards = awards.filter(item => this.countriesFilter.includes(item.country_id))
      }

      if (this.themesFilter.length) {
        awards = awards.filter(item => this.themesFilter.includes(item.theme_id))
      }

      if (this.establishmentYearFilter) {
        awards = awards.filter(item => parseInt(item.establishment_year) === this.establishmentYearFilter)
      }

      if (this.nominationsFilter.length) {
        awards = awards.filter(item => this.nominationsFilter.includes(item.nomination))
      }

      if (this.prizeMoneyFilter.length) {
        awards = awards.filter(item => {
          const containsMatchingPrizeMoney = this.prizeMoneyFilter
            .filter(i => {
              if (i.label === 'Yes') {
                return item.prize_money > 0
              } else if (i.label === 'No') {
                return item.prize_money === 0
              } else if (i.label === 'Unknown') {
                return item.prize_money == null
              }
              return i.min < item.prize_money && i.max >= item.prize_money
            })

          return containsMatchingPrizeMoney.length > 0
        })
      }

      // Deadline
      if (this.deadlineDateFrom) {
        awards = awards.filter(item => {
          return item.deadline > this.deadlineDateFrom
        })
      }
      if (this.deadlineDateTo) {
        awards = awards.filter(item => {
          return item.deadline < this.deadlineDateTo
        })
      }

      // Upcoming Ceremony
      if (this.upcomingCeremonyDateFrom) {
        awards = awards.filter(item => {
          if (!item.ceremony_dates) {
            return false
          }
          const ceremonyDates = JSON.parse(item.ceremony_dates)
          if (!ceremonyDates.length) {
            return false
          }
          for (var i = 0; i < ceremonyDates.length; i++) {
            if (this.moment(ceremonyDates[i]).isBefore(this.moment(this.upcomingCeremonyDateFrom))) {
              return false
            }
            return true
          }
        })
      }
      if (this.upcomingCeremonyDateTo) {
        awards = awards.filter(item => {
          if (!item.ceremony_dates) {
            return false
          }
          const ceremonyDates = JSON.parse(item.ceremony_dates)
          if (!ceremonyDates.length) {
            return false
          }
          for (var i = 0; i < ceremonyDates.length; i++) {
            if (this.moment(ceremonyDates[i]).isAfter(this.moment(this.upcomingCeremonyDateTo))) {
              return false
            }
            return true
          }
        })
      }

      // Ceased to Exist
      if (this.ceasedToExistYes && !this.ceasedToExistNo) {
        awards = awards.filter(item => item.ceased_to_exist)
      }
      if (this.ceasedToExistNo && !this.ceasedToExistYes) {
        awards = awards.filter(item => !item.ceased_to_exist)
      }

      return awards
    },

    pagesQty () {
      return this.filteredAwards.length % this.pageSize > 0 ? parseInt(this.filteredAwards.length / this.pageSize) + 1 : parseInt(this.filteredAwards.length / this.pageSize)
    },

    paginatedAwards () {
      return this.filteredAwards.slice((this.pageNumber - 1) * this.pageSize, this.pageNumber * this.pageSize)
    },

    years () {
      const years = []

      for (var i = this.moment().add(5, 'year').format('YYYY'); i >= 1900; i--) {
        years.push(i)
      }

      return years
    }
  },

  watch: {
    pageSize () {
      this.pageNumber = 1
    },

    search () {
      if (!this.search) {
        this.pageNumber = 1
      }
    }
  },

  methods: {
    callConfirmAwardDeleteDialog (item) {
      this.awardToDelete = item

      this.$refs.confirmAwardDeleteDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.deleteAward()
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    deleteAward () {
      this.$http.delete('/awards/' + this.awardToDelete.id)
        .then(({ data }) => {
          this.awards = this.awards.filter(item => item.id !== this.awardToDelete.id)

          this.showSuccessMessage('Award was deleted successfully!')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getAwards () {
      return this.$http.get('/awards?with_relations=1')
        .then(({ data }) => {
          this.awards = data.awards
        })
        .catch(error => {
          console.log(error)
        })
    },

    getCountries () {
      return this.$http.get('/countries')
        .then(({ data }) => {
          this.countries = data.countries
        })
        .catch(error => {
          console.log(error)
        })
    },

    getGeofocuses () {
      return this.$http.get('/geofocuses')
        .then(({ data }) => {
          this.geofocuses = data.geofocuses
        })
        .catch(error => {
          console.log(error)
        })
    },

    getThemes () {
      return this.$http.get('/themes')
        .then(({ data }) => {
          this.themes = data.themes
        })
        .catch(error => {
          console.log(error)
        })
    },

    goToAward (id) {
      this.$router.push({ name: 'awards.edit', params: { id: id } })
    },

    refreshFilters () {
      this.ceasedToExistYes = false
      this.ceasedToExistNo = false
      this.countriesFilter = []
      this.deadlineDateFrom = null
      this.deadlineDateTo = null
      this.establishmentYearFilter = ''
      this.frequenciesFilter = []
      this.geofocusesFilter = []
      this.nominationsFilter = []
      this.prizeMoneyFilter = []
      this.themesFilter = []
      this.upcomingCeremonyDateFrom = null
      this.upcomingCeremonyDateTo = null
    },

    sortBy (val) {
      this.sortByNameAsc = !this.sortByNameAsc

      this.awards.sort((a, b) => {
        const nameA = a[val] ? a[val].toUpperCase() : ''
        const nameB = b[val] ? b[val].toUpperCase() : ''
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByObj (val) {
      this.sortByNameAsc = !this.sortByNameAsc

      this.awards.sort((a, b) => {
        const nameA = a[val] ? a[val].name.toUpperCase() : ''
        const nameB = b[val] ? b[val].name.toUpperCase() : ''
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByPrizeMoney () {
      this.sortByNameAsc = !this.sortByNameAsc

      this.awards.sort((a, b) => {
        const nameA = a.prize_money ? parseInt(a.prize_money) : 0
        const nameB = b.prize_money ? parseInt(b.prize_money) : 0
        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByYearFounded () {
      this.sortByNameAsc = !this.sortByNameAsc

      this.awards.sort((a, b) => {
        const nameA = a.establishment_year
        const nameB = b.establishment_year
        if (nameA === null && nameB === null) {
          return 0
        }
        if (nameA === null) {
          return 1
        }
        if (nameB === null) {
          return -1
        }
        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    }
  }
}
</script>

<style scoped>
  .th-award-name,
  .th-award-theme {
    min-width: 200px;
  }

  .th-clickable:hover {
    background-color: #eceff1;
    cursor: pointer;
  }

  .th-deadline {
    min-width: 110px;
  }

  .search >>> .v-input__slot {
    background: rgba(0,0,0,.06) !important;
  }

  .search-no-results >>> .v-input__slot {
    background: #ffcdd2 !important;
  }

  .email-address {
    text-decoration: none;
  }

  .td-avatar {
    text-align: center;
  }

  .td-avatar img {
    max-height: 48px;
    max-width: 48px;
    vertical-align: middle;
  }

  .add-award-btn {
    position: absolute;
    right: 0;
  }

  .tr-award:hover {
    cursor: pointer;
  }
</style>
